import { Outlet } from "react-router-dom";
import { GenericFormProvider } from "./GenericFormContext";

const GenericFormContextLayout = ({ value }) => {
  return (
    <GenericFormProvider
      formDataName={value.formDataName}
      emptyFormData={value.emptyFormData}
    >
      <Outlet />
    </GenericFormProvider>
  );
};

export default GenericFormContextLayout;
